import { useState } from "react";
import InsertProductModal from "../modals/InsertProduct";
import EditProductModal from "../modals/EditProduct";
import { Page, DataTable } from "@iq/models";
import { FiPlus } from "react-icons/fi";

const PRODUCT_TABLE_CONFIG = {
    columns: [
        { 
            key: "name", 
            label: "Name", 
            accessor: (row) => row?.name || "-", 
            filterable: true,
            quickValues: ["A–E", "F–J", "K–O", "P–T", "U–Z"]
        },
        { 
            key: "description", 
            label: "Description", 
            accessor: (row) => row?.description || "-", 
            filterable: false 
        },
        { 
            key: "price", 
            label: "Price", 
            accessor: (row) => row?.price ?? row?.unit_price ?? "-", 
            filterable: false 
        },
        { 
            key: "stock", 
            label: "Stock", 
            accessor: (row) => row?.stock ?? row?.inventory ?? "-", 
            filterable: true,
            quickValues: ["In Stock", "Low Stock", "Out of Stock"]
        },
        { 
            key: "status", 
            label: "Status", 
            accessor: (row) => row?.status || "-", 
            filterable: true,
            quickValues: ["Active", "Pending", "Inactive"]
        },
    ],
};

function Products({ products = [], loading = false, error = "", onProductInserted }) {
    const rows = Array.isArray(products) ? products : [];
    const [showInsertProductModal, setShowInsertProductModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);

    function handleCloseInsertProduct() {
        setShowInsertProductModal(false);
        onProductInserted?.();
    }

    function handleRowClick(product) {
        setSelectedProduct(product);
    }

    return (
        <Page>
            {error ? (
                <div className="form-error-message" role="alert" style={{ display: "flex", alignItems: "center", gap: "0.75rem" }}>
                    <span>{error}</span>
                    <button type="button" onClick={onProductInserted}>Retry</button>
                </div>
            ) : null}

            <div>
                <DataTable
                    rowData={rows}
                    loading={loading}
                    tableConfig={PRODUCT_TABLE_CONFIG}
                    onRowClick={handleRowClick}
                />

                <button
                    type="button"
                    onClick={() => setShowInsertProductModal(true)}
                    aria-label="Insert product"
                    style={{
                        position: "absolute",
                        right: "var(--space-6)",
                        bottom: "var(--space-6)",
                        width: "48px",
                        height: "48px",
                        borderRadius: "50%",
                        backgroundColor: "var(--color-highlight)",
                        color: "var(--color-bg-page)",
                        fontSize: "1.6rem",
                        lineHeight: 1,
                        border: "none",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        boxShadow: "var(--shadow-sm)",
                    }}
                >
                    <FiPlus size={24} />
                </button>
            </div>

            {showInsertProductModal && (
                <InsertProductModal
                    onClose={() => setShowInsertProductModal(false)}
                    onInserted={handleCloseInsertProduct}
                />
            )}

            {selectedProduct ? (
                <EditProductModal
                    product={selectedProduct}
                    onClose={() => setSelectedProduct(null)}
                    onInserted={() => {
                        setSelectedProduct(null);
                        onProductInserted?.();
                    }}
                />
            ) : null}
        </Page>
    );
}

export default Products;